import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Status, PutPartsSelection } from '../../services/apiTypes';
import {
  fetchPartsSelection as fetchPartsSelectionAPI,
  updatePartsSelection as updatePartsSelectionAPI,
  PartsSelectionParam,
} from './api';

interface partsSelectionState {
  status: Status;
}

const initialState: partsSelectionState = {
  status: 'idle',
};

export const fetchPartsSelection = createAsyncThunk(
  'partsSelection/fetchPartsSelection',
  async (params: PartsSelectionParam, { rejectWithValue }) => {
    try {
      return await fetchPartsSelectionAPI(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updatePartsSelection = createAsyncThunk(
  'partsSelection/updatePartsSelection',
  async (newPartsSelection: PutPartsSelection, { rejectWithValue }) => {
    try {
      const putPartsSelection = newPartsSelection;
      return await updatePartsSelectionAPI(putPartsSelection);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const partsSelectionSlice = createSlice({
  name: 'partsSelection',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPartsSelection.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPartsSelection.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(fetchPartsSelection.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(updatePartsSelection.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updatePartsSelection.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(updatePartsSelection.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export default partsSelectionSlice.reducer;
